// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__HBEu3","row":"ProcedureTreatmentSummary_row__2ZOM5"};